import { animationHelpers } from '@hh/global.js'

class StaggeredMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback () {
    this.track = this.querySelector('[data-staggered-media-track]')
    this.trackInner = this.querySelector('[data-staggered-media-track-inner]')
    if (!this.track || !this.trackInner) { return null }

    this.setHeights()

    animationHelpers.createIntersectionObserver(
      this,
      (inView) => {
        if (inView) {
          window.addEventListener('scroll', this.scrollCheck.bind(this))
        } else {
          window.removeEventListener('scroll', this.scrollCheck.bind(this))
        }
      },
      {
        onlyCallbackOnIntersection: false,
        disableAfterIntersection: false,
        threshold: 0
      }
    )

    window.addEventListener('resize', this.setHeights.bind(this))
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.scrollCheck.bind(this))
    window.removeEventListener('resize', this.setHeights.bind(this))
  }

  setHeights () {
    this.trackHeight = this.track.getBoundingClientRect().height
    this.trackInnerHeight = this.trackInner.getBoundingClientRect().height

    this.scrollCheck()
  }

  scrollCheck () {
    const halfPercent = animationHelpers.scrollThroughPercentage(this, 0.5)
    const adjustedPercent = halfPercent < 0
      ? 0
      : halfPercent > 100
      ? 100
      : halfPercent

    const bottomAdjustment = (this.trackHeight - this.trackInnerHeight) * (adjustedPercent / 100)
    this.style.setProperty('--bottom-position', bottomAdjustment + 'px')
  }
}

customElements.define('staggered-media', StaggeredMedia);
